import { render, staticRenderFns } from "./simplePagination.vue?vue&type=template&id=3047af90&"
import script from "./simplePagination.vue?vue&type=script&lang=js&"
export * from "./simplePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports